import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function OneCardMeter() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "cmeter1";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
     gameName={"1 Card Meter"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container one-card-meter"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
              1 Card Meter
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>153250425162151</span>
              </small>
            </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul>
            <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>153250425162151</span>
              </span>
            </div>
          </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/cmeter1/57951df6-2f3a-4cbc-9c14-3eb3c8a35599?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
                <div className="d-flex flex-wrap justify-content-between">
                  <div>
                    <div className="flip-card-container">
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
      {/* <div className="clock flip-clock-wrapper">
                <ul className="flip play">
                  <li className="flip-clock-before">
                    <a href="#">
                      <div className="up">
                        <div className="shadow" />
                        <div className="inn">1</div>
                      </div>
                      <div className="down">
                        <div className="shadow" />
                        <div className="inn">1</div>
                      </div>
                    </a>
                  </li>
                  <li className="flip-clock-active">
                    <a href="#">
                      <div className="up">
                        <div className="shadow" />
                        <div className="inn">0</div>
                      </div>
                      <div className="down">
                        <div className="shadow" />
                        <div className="inn">0</div>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul className="flip play">
                  <li className="flip-clock-before">
                    <a href="#">
                      <div className="up">
                        <div className="shadow" />
                        <div className="inn">3</div>
                      </div>
                      <div className="down">
                        <div className="shadow" />
                        <div className="inn">3</div>
                      </div>
                    </a>
                  </li>
                  <li className="flip-clock-active">
                    <a href="#">
                      <div className="up">
                        <div className="shadow" />
                        <div className="inn">2</div>
                      </div>
                      <div className="down">
                        <div className="shadow" />
                        <div className="inn">2</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-full-box">
            <div className="meter-btns">
              <div className="meter-btn">
                {/* <div className="meter-btn-box suspended-box"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Fighter A", casinoData, dispatch, "back")
                  }
                >
                  <button className="btn btn-fighter-1 back">
                    Fighter A
                    {/* {getOddForEntity("Fighter A", casinoData)} */}
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/fight.png"
                      alt="Fight"
                    />
                  </button>
                  <p className="casino-nation-book d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Fighter A")}
                  </p>
                </div>
                <div className="text-center book-green">
                  <b />
                </div>
              </div>
              <div className="meter-btn">
                {/* <div className="meter-btn-box suspended-box"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Fighter B", casinoData, dispatch, "back")
                  }
                >
                  <button className="btn btn-fighter-2 back">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/fight.png"
                      alt="Fight"
                    />
                    Fighter B
                    {/* {getOddForEntity("Fighter B", casinoData, true)} */}
                  </button>
                  <p className="casino-nation-book d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Fighter B")}
                  </p>
                </div>
                <div className="text-center book-green">
                  <b />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casino-results/cmeter1">View All</a>
                </span>
              </div>
              <div className="casino-last-results">
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
              </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>My Bet</h4>
          </div>
          <div className="my-bets">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
